import i18next from "i18next";
import detector from "i18next-browser-languagedetector";
import translationEN from "./locales/en/translation.json";
import translationPT from "./locales/pt/translation.json";

const resources = {
  en: {
    translation: translationEN,
  },
  pt: {
    translation: translationPT,
  },
};
i18next.use(detector).init({
  debug: true,
  fallbackLng: ["en", "pt"],
  resources,
});

export default i18next;
